import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../common/types';
import { TeamAcceptHeading } from './TeamAcceptHeading';
import { acceptMessages } from './teamAcceptMessages';
import styles from './TeamAcceptAlreadyMemberHeading.module.scss';

interface TeamAcceptAlreadyMemberHeadingProps {
  workspaceName: string;
}

/** design: workspaces c5. A green check (not an error), then "You are already in {workspace}." */
const TeamAcceptAlreadyMemberHeadingComponent: React.FC<TeamAcceptAlreadyMemberHeadingProps> = ({ workspaceName }) => {
  const intl = useIntl();

  return (
    <>
      <div className={`mb-3 ${styles.okIcon}`}>
        <FontAwesomeIcon icon={faCheck} />
      </div>
      <TeamAcceptHeading
        title={intl.formatMessage(acceptMessages.alreadyMember, { workspace: workspaceName })}
        lead={intl.formatMessage({
          id: 'app.sml.team.accept.alreadyMemberLead',
          defaultMessage:
            'This invite is not needed. Open the workspace from here or from the menu at the top of the sidebar.',
        })}
      />
    </>
  );
};

export const TeamAcceptAlreadyMemberHeading = TypedMemo(TeamAcceptAlreadyMemberHeadingComponent);
